import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { PanelInfoIcon } from '@src/components/common/icon';

interface IStyledLabel {
	isRequired: boolean;
	hasTooltip?: boolean;
}

const Label = styled.label.attrs({ className: 'label' })`
	position: relative;
	margin-bottom: 4px;
	font-size: 14px;
	font-weight: 400;
	color: #333333;
	:after {
		content: "*";
		position: absolute;
		top: 0;
		display: ${(props: IStyledLabel) => (props.isRequired ? 'inline-block' : 'none')};
		padding-left: ${(props: IStyledLabel) => (props.hasTooltip ? '23px' : '2px')};
		margin-right: 4px;
		font-size: 14px;
		color: #D0021B;
	}
`;

const InfoIcon = styled(PanelInfoIcon)`
	width: 22px;
	height: 22px;
`;

interface ILabel {
	children: string | JSX.Element;
	htmlFor?: string;
	isRequired?: boolean;
	className?: string;
	tooltip?: string;
	tooltipPopupContainer?: string
	style?: React.CSSProperties;
}

const InputLabel = ({
	children, htmlFor, isRequired = false, className, tooltip, tooltipPopupContainer, style,
}: ILabel):JSX.Element => (
	<Label
		htmlFor={htmlFor}
		isRequired={isRequired}
		className={className}
		hasTooltip={!!tooltip}
		style={style}
	>
		{children}
		{
			tooltip && (
				<Tooltip
					className="popover"
					placement="topLeft"
					title={tooltip}
					// eslint-disable-next-line max-len
					{...tooltipPopupContainer ? { getPopupContainer: () => document.querySelector(tooltipPopupContainer) } : {}}
				>
					<InfoIcon />
				</Tooltip>
			)
		}
	</Label>
);

export default InputLabel;
